import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import Box from '@mui/material/Box';
import CompleteCertificateView from '../shared/completeCertificateView'

export default function ProjectCertificateCard({ image, heading, link, techStack, certificate}) {

  const handleButtonClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <Card
      sx={{
        maxWidth: 330,
        border: '7px solid var(--orangeCard)',
        borderRadius: 6,
        mt: 4,
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
          transform: 'scale(1.05)',  // Slightly scale up the card
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',  // Add a shadow for depth
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 1.5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CardMedia
            component="img"
            height = {certificate ? "200" : "160"}
            image={image}
            alt={heading}
            sx={{ margin: "0 auto", borderRadius: 3 }}
          />
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {heading}
            </Typography>
            {!certificate && <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
              <b>Tech Stack</b> : {techStack.join(', ')} {/* Convert array to string for display */}
            </Typography>}
          </CardContent>
        </Box>
        <CardActions>
          {/* -------- */}
          {certificate ? <CompleteCertificateView image={image} heading={heading} /> : <Button
            sx={{
              width: "8rem",
              height: "2.5rem",
              color: "white",
              borderRadius: "20px",
              fontWeight: "bold",
              backgroundColor: 'var(--orange)',
              '&:hover': {
                backgroundColor: 'var(--darkOrange)', 
              },
            }}
            className="button"
            onClick={handleButtonClick}
          >
            Demo
          </Button> }
          {/* ------ */}
        </CardActions>
      </Box>
    </Card>
  );
}